<template>
    <div class="container-users">
        <div class="switch-header">
            <ui-switch
                data-ui="limit-reservations-per-user"
                design="xs"
                label="Se ativado, as regras serão aplicadas imediatamente aos usuários adicionados."
                v-model="active"
                :checked="active"
                @click="enableButton = false"
            />
        </div>

        <div v-if="loading" class="container-loading">
            <ui-load-indicator bg-color="#e7e9f4" color="#3FACFF" :h="50" :stroke="8" />
        </div>

        <div v-if="active && !loading" class="container-users-table">
            <div v-if="hasReserves && !newUsers" class="container-has-reserves">
                <span>Você não cadastrou limite de reservas para usuário.</span>

                <ui-button data-ui="reverses-new-users" design="line-primary md" @click="newUsers = true, newUsersFixed = true">
                    <div class="text-center">
                        <em class="fal fa-plus" />
                        Adicionar Usuário
                    </div>
                </ui-button>
            </div>

            <ui-table
                v-if="!hasReserves"
                not-found-icon="fa fa-file-contract"
                not-found-text="Não foi possível encontrar nenhum Usuário"
                name="table-users"
                tr-component="products/permissions/reserves/components/users/users-table-line"
                max-height="409px"
                scroll-color="scroll-color-primary"
                line-white
                :is-fixed-list="false"
                :columns="tableColumns"
                :loading="false"
                :last-col-fixed="false"
                :select-column-menu="false"
                :data="tableData"
            />

            <div v-if="newUsers" class="actions-add-user">
                <div class="select-team-user">
                    <div class="container-select">
                        <ui-select-v2
                            return-value="id"
                            item-label="label"
                            placeholder="Equipes"
                            design="brr-0"
                            class="hidden-mr"
                            data-ui="reserves-select-teams"
                            v-model="form.teams"
                            :loading="isTeamsLoading"
                            :data="options.teams"
                            :search="true"
                            @input="getUsers('')"
                        />
                    </div>

                    <div class="container-select">
                        <ui-select-v2
                            return-value="id"
                            item-label="first_name"
                            placeholder="Usuários"
                            design="brl-0"
                            data-ui="reserves-select-users"
                            v-model="form.users"
                            :loading="isUsersLoading"
                            :data="options.users"
                            :search="true"
                        />
                    </div>
                </div>

                <span
                    class="cancel"
                    :class="{ disabled: addUser }"
                    @click="cancelUser"
                >
                    Cancelar
                </span>

                <span
                    class="confirm"
                    :class="{ disabled: addUser }"
                    @click="confirmUser"
                >
                    Confirmar
                </span>
            </div>

            <div v-if="newUsersFixed || tableData.length > 0" class="add-user">
                <div class="button-add-user">
                    <em class="fal fa-plus" />

                    <span class="add-user-underline" @click="newUsers = true">Adicionar Usuário</span>
                </div>
            </div>

            <div class="ignored-limit">
                <span class="text-ignored-limt">
                    Ignorar limite de reservas do <b>responsável do negócio</b> quando reserva for criada pelo administrador ou colaborador.
                </span>

                <ui-switch
                    data-ui="limit-reservations-per-user"
                    design="xs"
                    v-model="ignoreLimitActive"
                    :checked="ignoreLimitActive"
                    @click="enableButton = false"
                />
            </div>
        </div>

        <div class="footer-permissions-reservations">
            <!-- <div class="img-text">
                <img :src="require('@/assets/imgs/svg/crown.png')" />

                <span>Conheça mais funcionalidades da <span class="professional-management" @click="openConfigurationsReserves">Gestão Profissional.</span></span>
            </div> -->

            <div class="button-submit">
                <ui-button
                    data-ui="submit-reservations-per-user"
                    design="success md"
                    :disabled="enableButton"
                    @click="submit"
                >
                    <span v-if="loadingButton" class="loading-submit-user">
                        <ui-load-indicator bg-color="#fff" color="#41A870" :h="20" :stroke="6" />
                    </span>

                    Salvar
                </ui-button>
            </div>
        </div>
    </div>
</template>

<script>
import { uiLoadIndicator, uiTable } from '@/components/ui'
import { uiButton } from '@/components/ui/buttons'
import { uiSelectV2, uiSwitch } from '@/components/ui/form'
import { alertMixin } from '@/mixins'
import { reserves, teamsList, usersList } from '@/services/axios'

const defaultOptionsArray = () => ({
    teams: [],
    users: []
})

const defaultFormData = function () {
    return {
        teams: null,
        users: []
    }
}

const perPage = 250

export default {
    name: 'ui-products-permissions-reserves-users',

    components: {
        uiSwitch,
        uiTable,
        uiLoadIndicator,
        uiButton,
        uiSelectV2
    },

    props: {
        users: {
            type: Object,
            default: () => {}
        }
    },

    mixins: [
        alertMixin
    ],

    data() {
        return {
            loading: false,
            loadingButton: false,
            hasReserves: false,
            active: false,
            isTeamsLoading: false,
            isUsersLoading: false,
            enableButton: true,
            newUsers: false,
            newUsersFixed: false,
            product_id: null,
            type: 'users',
            configurationsData: [],
            options: { ...defaultOptionsArray() },
            tableColumns: [
                { title: 'Usuários' },
                { title: 'Reservas Realizadas' },
                { title: 'Limite de Reservas' },
                { title: '' }
            ],
            tableData: [],
            form: { ...defaultFormData() },
            addUser: false,
            ignoreLimitActive: false
        }
    },

    async mounted() {
        this.product_id = this.$route.params.id
        this.loading = true

        if (this.users?.config) {
            this.tableData = this.users.config
            this.hasReserves = this.users.config.length === 0
            this.active = this.users.active
            this.ignoreLimitActive = this.users.ignore_limit_active
            this.loading = false
        } else this.loading = false

        await Promise.all([
            this.getTeams(),
            this.getUsers()
        ])

        this.$root.$on('new-limit-group-users', payload => {
            // Verifica se já existe um item com o mesmo ID no array
            const index = this.configurationsData.findIndex(item => item.id === payload.id)
            this.enableButton = false

            if (index !== -1) {
                // Se já existe, atualiza os dados
                this.configurationsData[index] = payload
            } else {
                // Se não existe, adiciona um novo
                this.configurationsData.push(payload)
            }
        })

        this.$root.$on('remove-user', payload => {
            this.tableData = this.tableData.filter(item => item.id !== payload.id)
            this.enableButton = false
            this.newUsersFixed = true
        })
    },

    methods: {
        /**
         * Busca as equipes
        */
        // ?whereHas=products.id:7&orderBy=id

        async getTeams() {
            this.isTeamsLoading = true
            /** Carrega as opções de equipes cadastradas */
            try {
                const response = await teamsList.getAllV2('', {
                    whereHas: `products.id:${this.product_id}&orderBy=id`
                })

                if (response.data) {
                    let data = Object.values(response.data.data).map(team => {
                        return { id: team.id, value: team.id, label: team.name }
                    })
                    this.options.teams = data
                }
                this.isTeamsLoading = false
            } catch (error) {
                if (error.data?.msg) {
                    this.$mx_alertError(error.data.msg)
                }
                this.isTeamsLoading = false
            } finally {
                this.isTeamsLoading = false
            }
        },

        async getUsers(id) {
            this.isUsersLoading = true
            this.clearFilterUsers()
            let params = null
            let hasTableData = []

            if (this.tableData) {
                hasTableData = [ ...this.tableData.filter(item => item.id).map(item => item.id) ]
            } else if (this.users?.config) {
                hasTableData = [ ...this.users.config.filter(item => item.id).map(item => item.id) ]
            }

            params = {
                whereHas: `group.products.id:${this.product_id};teams.products.id:${this.product_id}${this.form?.teams ? ';groups.name:broker,manager,supervisor;teams.id:' + this.form?.teams : ';group.name!:admin,collaborator'}${id ? ';teams::products.id:' + this.product_id : ''}`,
                select: 'id,first_name,last_name',
                with: `${id ? 'teams;withCount:reservedUser as reserves_total' : ''}`,
                where: `status:active${id ? `;id:${id}` : ''}${hasTableData.length > 0 ? `;id!:${hasTableData}` : ''}`,
            }

            params = Object.fromEntries(Object.entries(params).filter(([_, v]) => v !== undefined && v !== null));

            /** Carrega as opções de equipes cadastradas */
            try {
                const response = await usersList.getAllV2('', params)

                if (response.data?.data) {
                    let data = Object.values(response.data.data).map(user => {
                        return {
                            id: user.id,
                            teams: user.teams ? [ ...user.teams ] : [],
                            first_name: `${user.first_name ?? ''} ${user.last_name ?? ''}`,
                            reserves_total: user.reserves_total ?? 0,
                            photo: user.photo,
                            limit: 50
                        }
                    })
                    this.options.users = data
                }
                this.isUsersLoading = false
            } catch (error) {
                if (error.data?.msg) {
                    this.$mx_alertError(error.data.msg)
                }
                this.isUsersLoading = false
            } finally {
                this.isUsersLoading = false
            }
        },

        async submit() {
            this.loadingButton = true
            this.enableButton = true

            let configurations = [
                ...this.configurationsData,
                ...this.tableData.filter(user => !this.configurationsData.some(config => config.id === user.id))
            ].map(({ id, limit }) => ({ id, limit }))

            let data = {
                type: this.type,
                active: this.active,
                product_id: this.product_id,
                configurations: [ ...configurations ],
                ignore_limit_active: this.ignoreLimitActive
            }

            try {
                const response = await reserves.postConfigLimitProduct(data)
                this.$mx_alertSuccess(response.data.msg)
                this.loadingButton = false
            } catch (error) {
                if (error.data?.msg) {
                    this.$mx_alertError(error.data.msg)
                } else {
                    this.$mx_alertError(error)
                }
                this.loading = false
                this.loadingButton = false
                this.enableButton = false
            } finally {
                this.loading = false
                this.loadingButton = false
            }
        },

        clearFilterUsers() {
            this.options.users = []
        },

        async confirmUser() {
            this.addUser = true
            await this.getUsers(this.form?.users)
            let filterUser = this.options?.users?.filter(user => user?.id === this.form?.users)
            this.tableData = [ ...filterUser, ...this.tableData ]
            this.hasReserves = this.tableData?.length === 0
            this.newUsers = false
            this.enableButton = false
            this.addUser = false
            this.$root.$emit('clean-select-v2')
        },

        cancelUser() {
            this.clearFilterUsers()
            this.newUsers = false
        },

        openConfigurationsReserves() {
            this.$router.push({
                name: 'configurations.reserves.professional.management'
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>